import { ref } from 'vue';
import { defineStore } from "pinia";
import { store } from "@/store";

export const usePageStatusStore = defineStore("pageStatus",()=>{
    const firstEnterLoading = sessionStorage.getItem('firstEnterLoading')?ref(JSON.parse(sessionStorage.getItem('firstEnterLoading'))):ref(true) //首次加载
    const sideBarStatus = ref(true);
    
    /**
   * 首次进入页面loading
   */
    function changeLoadingStatus(){
        firstEnterLoading.value = false;
        sessionStorage.setItem('firstEnterLoading',JSON.stringify(firstEnterLoading.value))
    }

    /**
   * 侧边栏隐藏/显示
   */
    function changeSideBarStatus(status){
        sideBarStatus.value = status;
    }

    return {
        firstEnterLoading,
        sideBarStatus,
        changeLoadingStatus,
        changeSideBarStatus
    }
});

// 非setup
export function usePageStatusStoreHook() {
    return usePageStatusStore(store);
}